import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { UserService } from 'src/app/Service/User/User.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-Lockscreen',
  templateUrl: './Lockscreen.component.html',
  styleUrls: ['./Lockscreen.component.scss']
})
export class LockscreenComponent implements OnInit {


  Fullname: String = ""
  ValidationCode: String = ""
  BaserUrlImage: string = environment.BaseUrl
  SecondCounter: number = 0;
  ProccesingPassword: boolean = false
  MainBackground:number=0

  constructor(
    private User_Service: UserService,
    private Alertify_Service: AlertifyService,
    private login_Service: LoginService,
    public router: Router
  ) { }

  ngOnInit() {
    this.MainBackground = this.randomIntFromInterval(1, 6)
    this.Fullname = localStorage.getItem('Daro_User_Fullname');
    this.BaserUrlImage = this.BaserUrlImage + localStorage.getItem('Daro_User_UserImage')

    setInterval(() => {
      this.SecondCounter = this.SecondCounter - 1

    }, 1000);




    this.ValidationUser = new FormGroup({
      Phone: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10}$')]),
      Password: new FormControl('', Validators.required),
      RePassword: new FormControl('', Validators.required),
      Code: new FormControl('', Validators.required),
    })

  }


  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }


  //#region  Form Add

  ValidationUser: FormGroup;

  get_Form_Phone() {
    return this.ValidationUser.get('Phone') as FormControl;
  }
  get_Form_Password() {
    return this.ValidationUser.get('Password') as FormControl;
  }
  get_Form_RePassword() {
    return this.ValidationUser.get('RePassword') as FormControl;
  }
  get_Form_Code() {
    return this.ValidationUser.get('Code') as FormControl;
  }



  //#endregion

  SendValidationCode() {
    this.SecondCounter = 120
    this.User_Service.ValidationCode(this.get_Form_Phone().value).subscribe(
      data => {
        this.ValidationCode = data['code']


      }
    )
  }

  SubmitValidationUser() {
    if (this.get_Form_Password().value != this.get_Form_RePassword().value) {
      this.Alertify_Service.ErrorMessage("رمز عبور جدید با تکرار آن یکی نمی باشد")
    }
    else if (this.ValidationCode != this.get_Form_Code().value) {
      this.Alertify_Service.ErrorMessage("کد ارسال صحیح وارد نشده است")
    }
    else {
      this.ProccesingPassword = true
      this.login_Service.MustChangePassword(this.get_Form_Password().value).subscribe(
        data => {

          if(data['token']=='-1')
          {
            this.Alertify_Service.ErrorMessage("رمز عبور جدید دیگری انتخاب نمائید")
          }
          else{
            this.ProccesingPassword = false
            this.Alertify_Service.SuccessMessage(this.Fullname + " خوش آمدید ")
            this.router.navigate(['/Dashboard']);
            this.ReadData_Loging_KeySearch()
          }
        }
      )
    }
  }

  ReadData_Loging_KeySearch_Timer: any
  ReadData_Loging_KeySearch() {

    if (this.ReadData_Loging_KeySearch_Timer) {
      clearTimeout(this.ReadData_Loging_KeySearch_Timer);
      this.ReadData_Loging_KeySearch_Timer = null;
    }

    this.ReadData_Loging_KeySearch_Timer = setTimeout(function () {
      this.LogingFunctionReload()
    }.bind(this), 1000);

  }

  LogingFunctionReload() {
    location.reload();
  }





}
